module.exports = __webpack_public_path__ + "static/media/my-order.502f7ace.svg";